export default __webpack_public_path__ + "static/hss-sm-fdbbce5a44c404a5390dfede7f5b9b73.mp4";